import { WholeCatalogProvider } from './useWholeCatalogContext'
import { WholeCatalog, WholeCatalogProps } from './WholeCatalog'

export const WholeCatalogContainer = (props: WholeCatalogProps) => (
	<WholeCatalogProvider>
		<WholeCatalog {...props} />
	</WholeCatalogProvider>
)
